import TCarouselSetting from "./TCarouselSetting";
import {CheckboxItem} from "../../../../model/items/checkbox";
import m, {Vnode, VnodeDOM} from "mithril";
import {Questionary} from "../../../../model/questionary";
import ImageDialog from "../Image/ImageDialog";

export default class Carousel {

    private imageDialog: null|ImageDialog = null;

    private mouseDown = false;
    private _page = -1;
    private startX = 0;
    private direction: -1|0|1 = 0;

    private shouldCancelClickEvent = false;

    private scrollingTimeout = 0;

    private uniqueId = Math.round(Math.random() * 1000000);

    constructor(
        public readonly setting: TCarouselSetting,
        private readonly validationBox: CheckboxItem|null,
        private readonly questionary: Questionary,
    ) {
        if (setting.images.length <= 1) {
            this.makeValid();
        }
        this.page = 0;
    }

    private set page(page: number) {
        if (this._page !== page && page >=0 && page < this.setting.images.length) {
            this._page = page;
            this.imageDialog = new ImageDialog(this.setting.images[page]);
            if (page === this.setting.images.length-1) {
                this.makeValid();
            }
        }
    }

    private get page(): number {
        return this._page;
    }

    private computePage(carouselEl: HTMLElement): number {
        const carouselLeft = carouselEl.getBoundingClientRect().left;
        Array.from(carouselEl.children).some((child, i) => {
            if (child.getBoundingClientRect().left >= carouselLeft) {
                this.page = i;
                return true;
            }
            return false;
        });
        return this.page;
    }

    private makeValid(): void {
        this.validationBox?.setVariable(true);
    }

    private createAnchor(n: number): string {
        return `carousel-${this.uniqueId}-slide-${n}`
    }

    private startDragging(e: MouseEvent, el: HTMLElement): void {
        window.clearTimeout(this.scrollingTimeout);
        this.direction = 0;
        this.mouseDown = true;
        this.startX = e.pageX - el.offsetLeft;
    }

    private stopDragging(): void {
        if (this.mouseDown) {
            this.mouseDown = false;
            const targetPage = this.page + this.direction;
            location.hash = "#" + this.createAnchor(targetPage);
            setTimeout(() => this.shouldCancelClickEvent = false, 1); // safari shit
        }
    }

    private move(e: MouseEvent, el: HTMLElement): void {
        e.preventDefault();
        if (!this.mouseDown) {
            return;
        }
        this.shouldCancelClickEvent = true;
        const x = e.pageX - el.offsetLeft;
        const scroll = x - this.startX;
        if (scroll > 20) {
            this.direction = -1;
        } else if (scroll < -20) {
            this.direction = 1;
        } else {
            this.direction = 0;
        }
    }

    public view(): Vnode {
        return m('.Carousel', {}, [
            m('.Carousel-slides', {
                onscroll: (e: Event) => this.computePage(<HTMLElement>e.currentTarget),
                onmousemove: (e: MouseEvent) => this.move(e, <HTMLElement>e.currentTarget),
                onmousedown: (e: MouseEvent) => this.startDragging(e, <HTMLElement>e.currentTarget),
                onmouseup: () => this.stopDragging(),
                onmouseleave: () => this.stopDragging(),
            }, this.setting.images.map((givenUrl,i) => {
                const url = this.questionary.getFileUrl(givenUrl);
                return m('.carousel-slide', {
                    id: this.createAnchor(i),
                }, [
                    m('img', {
                        src: url,
                        draggable: false,
                        onclick: () => {
                            this.shouldCancelClickEvent || this.imageDialog?.showModal();
                            this.shouldCancelClickEvent = false;
                        },
                    }),
                    m('label', {}, String(i+1)),
                ])
            })),
            m('.carousel-prev', {
                onclick: () => location.hash = this.createAnchor(this.page-1)
            }, [
                m('i.icon.icon-chevron-left')
            ]),
            m('.carousel-next', {
                onclick: () => location.hash = this.createAnchor(this.page+1)
            }, [
                m('i.icon.icon-chevron-right')
            ]),
            this.imageDialog ? m(this.imageDialog) : null,
        ])
    }

}